import {Tariffs} from "../../tariffs/tariffs";
import {useEffect, useState} from "react";
import WindowPaySub from "../../app-main-profile/window-pay-sub/window-pay-sub";
import ExteriorNotice from "../../app-main-profile/popup-sections/pay-sub/exterior-notice";

export const TariffsPage = () => {
    const currentLink = new URL(window.location.href);
    const [showModal, setShowModal] = useState(!!currentLink.searchParams.get("subSelect"))
    const [showExteriorNotice, setShowExteriorNotice] = useState(false);
    const [subNameSelect, setSubNameSelect] = useState(currentLink.searchParams.get("subNameSelect"));
    const [subSelect, setSubSelect] = useState(currentLink.searchParams.get("subSelect"));
    const [defaultOptionMonth, setDefaultOptionMonth] = useState(+(currentLink.searchParams.get("optionMonth") || 0));

    useEffect(() => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete("subSelect");
        currentUrl.searchParams.delete("subNameSelect");
        currentUrl.searchParams.delete("optionMonth");
        window.history.replaceState(null, null, currentUrl.toString());
    }, [])

    return (
        <div>
            {showModal && (
                <WindowPaySub
                    setShowExteriorNotice={setShowExteriorNotice}
                    subNameSelect={subNameSelect}
                    subSelect={subSelect}
                    setShowModal={setShowModal}
                    defaultOptionMonth={defaultOptionMonth}
                />
            )}
            {showExteriorNotice && <ExteriorNotice setShowExteriorNotice={setShowExteriorNotice} />}
            <Tariffs setShowModal={setShowModal}
                     setSubNameSelect={setSubNameSelect}
                     setSubSelect={setSubSelect}
                     setDefaultOptionMonth={setDefaultOptionMonth}
            />
        </div>
    );
};